import type { AxiosResponse } from 'axios';
import type StatesEnum from '@/utils/enums/StatesEnum';
import { ApiService } from '@/services/api';
import type { mscPipelineResponseType } from './types';

type Params = {
  mscPipelineId: string;
  selectionProcessId: string;
  event: StatesEnum;
  creditCheckAuth?: boolean;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  otherEventFields?: any;
};

type useMscPipelineType = {
  changeMscPipeline: (
    params: Params,
  ) => Promise<AxiosResponse<mscPipelineResponseType>>;
};

function useMscPipeline(): useMscPipelineType {
  const { api } = ApiService();

  function changeMscPipeline({
    mscPipelineId,
    selectionProcessId,
    event,
    creditCheckAuth,
    otherEventFields,
  }: Params) {
    return api.put<mscPipelineResponseType>(
      `/fintech/v1/msc_pipelines/${mscPipelineId}`,
      {
        selection_process_id: selectionProcessId,
        event,
        ...(creditCheckAuth && {
          credit_check_authorization: creditCheckAuth,
        }),
        ...otherEventFields,
      },
    );
  }

  return { changeMscPipeline };
}

export default useMscPipeline;
